<template>
  <v-dialog v-model="getJuryOptionsViewer.show" width="37%" persistent>
    <v-card class="pa-5 rounded-xl">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="1"></v-col>
        <v-col cols="10" align-self="center" align="center">
          <span class="justify-center text-h5 font-weight-bold">
            {{ getJuryOptionsViewer.dialogHeader }}
          </span>
        </v-col>
        <v-col cols="1" align-self="center" align="center">
          <v-btn icon @click="closeDialog()">
            <v-icon color="red" x-large>mdi-window-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-divider class="my-2"></v-divider>
        </v-col>
      </v-row>
      <v-card-text align="center" class="pa-0 mt-2">
        <v-row no-gutters>
          <v-col cols="6" v-for="(item, index) in getJuryOptionsViewer.dialogData" :key="index">
            <v-card class="my-5 d-flex justify-center align-center rounded-xl" width="265" height="225" @click="viewElement(item)"
              color="primary">
              <v-card-text class="white--text text-h5">
                <span v-if="typeof item === 'object'">
                  {{ item.displayText }}
                </span>
                <span v-else>
                  {{ item }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "juryOptionsViewer",
  data() {
    return {
      talkButtonSrc: "talkButton.png",
    };
  },
  computed: {
    ...mapGetters([
      "getJuryOptionsViewer",
      "getQnaStatus",
      "getResetKioskStatus"
    ]),
  },
  methods: {
    viewElement(input) {
      // Touch Usage
      console.log('Input: ', input)
      if (input === "Pay Online" || input === "Pagar en línea") {
        this.$store.dispatch("avatarSpeak", this.$i18n.t("payonline"));
        window.open("https://www.clericusmagnus.com/ePayoa_Lasalle.htm", "_blank")
      } else {
        this.$store.dispatch("openImageViewer", {
          name: "Circuit Clerk/ Traffic Fines",
          url: "https://cms.il-lasalle.arsconnect.com/uploads/clerkoffice_da2400327b.png",
        });
        this.$store.dispatch("avatarSpeak", this.$i18n.t("paycash"));
      }
      // this.$store.dispatch("requestQnA", input);
      // this.$store.commit("closeJuryOptionsViewer");
    },
    closeDialog() {
      this.$store.commit("closeJuryOptionsViewer");
    }
  }
};
</script>

<style scoped>
.talk-button {
  filter: sepia(19%) saturate(697%) hue-rotate(294deg) brightness(95%) contrast(350%);
}
</style>
<i18n>
{
  "en": {
      "payonline": "Here is the link to pay traffic ticket online.",
      "paycash": "To pay in cash please go to the Circuit Clerk/ Traffic fines office."
    },
  "es":{
      "payonline": "Aquí está el enlace para pagar la multa de tráfico en línea.",
      "paycash": "Para pagar en efectivo, por favor diríjase a la oficina del Secretario del Tribunal / multas de tráfico."
    }
}
</i18n>